import { Badge, type SemanticTone } from '@kerfjs/ui/badge';
import { type SafeHtml } from 'kerfjs';

export const VERDICT_LABELS: Record<string, string> = {
  fair: 'Fair',
  'slightly-high': 'Slightly high',
  high: 'High',
  'very-high': 'Very high',
  'below-market': 'Below market',
  'insufficient-data': 'Insufficient data',
  // Benchmarked, but no quote to judge yet (HS2-AX3JJY).
  estimate: 'No quote yet',
};
const VERDICT_TONE: Record<string, SemanticTone> = {
  fair: 'success',
  'slightly-high': 'warning',
  high: 'warning',
  'very-high': 'danger',
  'below-market': 'info',
  'insufficient-data': 'neutral',
  estimate: 'info',
};
export function VerdictChip({ verdict }: { verdict: string | null }): SafeHtml {
  const key = verdict ?? 'insufficient-data';
  return (
    <Badge tone={VERDICT_TONE[key] ?? 'neutral'} appearance="solid" shape="pill">
      {VERDICT_LABELS[key] ?? key}
    </Badge>
  );
}
